import { useTranslation } from 'react-i18next';
import { Card } from '@/components/ui/card';
import { PortalPageHeader } from '../PortalPageHeader';
import { ServicesSection } from '../ServicesSection';
import { PastVisitsList } from '../UpcomingVisitsCard/PastVisitsList';
import { UpcomingVisitsCard } from '../UpcomingVisitsCard';

export function VisitsPage() {
  const { t } = useTranslation('clients');

  return (
    <div className="p-4 sm:p-6 md:p-8">
      <PortalPageHeader
        title={t('portal.pages.visits.title')}
        helperText={t('portal.pages.visits.helper')}
      />
      <div className="space-y-5">
        <UpcomingVisitsCard />
        <Card as="section">
          <PastVisitsList />
        </Card>
        <ServicesSection />
      </div>
    </div>
  );
}
